export default __webpack_public_path__ + "static/media/weight_card_2@2x.7b54e7f7.png";